const body = document.querySelector('body')

function resolveIt(body) {
    return new Promise(resolve => {
        setTimeout(() => {
            body.classList.remove('disable-scroll')
        }, 4500);
    });
}

async function bringbackscroll(body) {
    body.classList.add('disable-scroll')
    const result = await resolveIt(body);
}

// only apply on home page
if (body.classList.contains('home')){

    // added timeoouts because scrollTo wasn't working without them
    setTimeout(()=> {
        window.scrollTo(0, 0)
    }, 100);
    setTimeout(()=> {
        // remove screen lock class asynchronicly in 6.5s
        bringbackscroll(body);
    }, 101);

    const header = document.querySelector('.header-content-wrapper')
    header.classList.add('animate-header')
}